// Design tokens for the "Stage Pop v2" direction.
// Translated from yoodajjom-handoff/project/pop-v2.jsx (coral palette).

export const COLORS: { [k: string]: number } = {
  coral: 0xff5a6e,
  yolk: 0xffc23c,
  plum: 0x2a1140,
  cream: 0xfff1d6,
  ink: 0x1a0826,
  white: 0xffffff,
  paper: 0xf0e6cc,
  emerald: 0x62d6b0,
  rose: 0xffb1d7,
  // Deep gray for secondary buttons — lifts off the ink border/shadow so the
  // button silhouette stays readable instead of blobbing into one dark shape.
  slate: 0x4a4452,
};

/** CSS-string equivalents for Phaser Text color / strokeColor. */
export const CSS: { [k: string]: string } = {
  coral: '#ff5a6e',
  yolk: '#ffc23c',
  plum: '#2a1140',
  cream: '#fff1d6',
  ink: '#1a0826',
  white: '#ffffff',
  paper: '#f0e6cc',
  emerald: '#62d6b0',
  rose: '#ffb1d7',
  inkSoft: 'rgba(26,8,38,0.65)',
  inkFaint: 'rgba(26,8,38,0.4)',
  inkGhost: 'rgba(26,8,38,0.15)',
  whiteSoft: 'rgba(255,255,255,0.7)',
  whiteFaint: 'rgba(255,255,255,0.35)',
  whiteGhost: 'rgba(255,255,255,0.16)',
};

export const FONT = {
  display: '"Fredoka", system-ui, sans-serif',
  title: '"Baloo 2", system-ui, sans-serif',
  body: '"Nunito", system-ui, sans-serif',
} as const;

/** Round corner sizes (px in 720-wide logical space). Roughly 2× the design values. */
export const RADIUS = {
  cut: 8,
  rounded: 32,
  pill: 999,
} as const;

/** Standard outline thickness for "outlined block" shapes (chunky cartoon style). */
export const OUTLINE = 6;
/** Default "drop shadow" vertical offset (rendered as solid ink rect under the fill). */
export const SHADOW_Y = 10;

/** Helper: convert numeric color (0xRRGGBB) to css hex string. */
export function toCss(n: number): string {
  return '#' + n.toString(16).padStart(6, '0');
}

/** Helper: numeric color + alpha → rgba() string. */
export function toRgba(n: number, alpha: number): string {
  const r = (n >> 16) & 0xff;
  const g = (n >> 8) & 0xff;
  const b = n & 0xff;
  return `rgba(${r},${g},${b},${alpha})`;
}
